import React from 'react';
import PropTypes from 'prop-types';

import styles from './IntraSection.css';
import { IconRight } from './img';

const itemTemplate = {
  link: PropTypes.string,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  description: PropTypes.string,
  descriptionColor: PropTypes.string,
};

const IPropTypes = {
  className: PropTypes.string,
  intraSection: PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape(itemTemplate)).isRequired,
  }).isRequired,
};

const defaultProps = {
  className: '',
};

const renderItem = item => (
  <div key={item.order} className={styles.itemContainer}>
    {
      item.title &&
      <span
        className={styles.itemTitle}
        style={{
          color: item.titleColor,
        }}
      >
        {item.title}
      </span>
    }
    {
      item.description &&
      <span
        className={styles.itemDescription}
        style={{
          color: item.descriptionColor,
        }}
      >
        {item.description}
      </span>
    }
  </div>
);

const renderLinkItem = linkItem => (
  <a
    key={linkItem.order}
    className={styles.linkItemContainer}
    href={linkItem.link}
    rel="noopener noreferrer"
    target="_blank"
  >
    <div>
      {
        linkItem.title &&
        <p
          className={[styles.linkText, styles.linkItemTitle].join(' ')}
          style={{
            color: linkItem.titleColor,
          }}
        >
          {linkItem.title}
        </p>
      }
      {
        linkItem.description &&
        <p
          className={[styles.linkText, styles.linkItemDescription].join(' ')}
          style={{
            color: linkItem.descriptionColor,
          }}
        >
          {linkItem.description}
        </p>
      }
    </div>
    <img src={IconRight} alt="" />
  </a>
);

const IntraSection = (props) => {
  const { intraSection: { title } } = props;
  return (
    <div className={[props.className, styles.container].join(' ')}>
      <p className={styles.title}>{title}</p>
      {
        props.intraSection.items.map((item) => {
          const isLink = item.link !== null;
          let itemToRender = null;
          if (isLink) {
            itemToRender = renderLinkItem(item);
          } else {
            itemToRender = renderItem(item);
          }
          return itemToRender;
        })
      }
    </div>
  );
};

IntraSection.propTypes = IPropTypes;
IntraSection.defaultProps = defaultProps;

export { IntraSection };



// WEBPACK FOOTER //
// ./src/pages/home/intra-section/IntraSection.jsx